module.exports = __webpack_public_path__ + "static/media/mgo3.6e330826.png";